import addIcon from '~Assets/icons/EPOS/FoodIcons/add.svg';
import beer from '~Assets/icons/EPOS/FoodIcons/beer.svg';
import bowl from '~Assets/icons/EPOS/FoodIcons/bowl.svg';
import breakfast from '~Assets/icons/EPOS/FoodIcons/breakfast.svg';
import burger from '~Assets/icons/EPOS/FoodIcons/burger.svg';
import burgerMenu from '~Assets/icons/EPOS/FoodIcons/burger-menu.svg';
import cake from '~Assets/icons/EPOS/FoodIcons/cake.svg';
import celebration from '~Assets/icons/EPOS/FoodIcons/celebration.svg';
import chefHat from '~Assets/icons/EPOS/FoodIcons/chef-hat.svg';
import chicken from '~Assets/icons/EPOS/FoodIcons/chicken.svg';
import chiliSauce from '~Assets/icons/EPOS/FoodIcons/chili-sauce.svg';
import cocktail from '~Assets/icons/EPOS/FoodIcons/cocktail.svg';
import coffee from '~Assets/icons/EPOS/FoodIcons/coffee.svg';
import coffeeTakeaway from '~Assets/icons/EPOS/FoodIcons/coffee-takeaway.svg';
import cookie from '~Assets/icons/EPOS/FoodIcons/cookie.svg';
import cow from '~Assets/icons/EPOS/FoodIcons/cow.svg';
import croissant from '~Assets/icons/EPOS/FoodIcons/croissant.svg';
import dining from '~Assets/icons/EPOS/FoodIcons/dining.svg';
import drink from '~Assets/icons/EPOS/FoodIcons/drink.svg';
import dumpling from '~Assets/icons/EPOS/FoodIcons/dumpling.svg';
import favorite from '~Assets/icons/EPOS/FoodIcons/favorite.svg';
import fish from '~Assets/icons/EPOS/FoodIcons/fish.svg';
import fish2 from '~Assets/icons/EPOS/FoodIcons/fish-2.svg';
import fries from '~Assets/icons/EPOS/FoodIcons/fries.svg';
import grill from '~Assets/icons/EPOS/FoodIcons/grill.svg';
import homeIcon from '~Assets/icons/EPOS/FoodIcons/home.svg';
import iceCream from '~Assets/icons/EPOS/FoodIcons/ice-cream.svg';
import juice from '~Assets/icons/EPOS/FoodIcons/juice.svg';
import kebab from '~Assets/icons/EPOS/FoodIcons/kebab.svg';
import kebab2 from '~Assets/icons/EPOS/FoodIcons/kebab-2.svg';
import lobster from '~Assets/icons/EPOS/FoodIcons/lobster.svg';
import pig from '~Assets/icons/EPOS/FoodIcons/pig.svg';
import pizza from '~Assets/icons/EPOS/FoodIcons/pizza.svg';
import plate from '~Assets/icons/EPOS/FoodIcons/plate.svg';
import plusOne from '~Assets/icons/EPOS/FoodIcons/plus-one.svg';
import ramen from '~Assets/icons/EPOS/FoodIcons/ramen.svg';
import rice from '~Assets/icons/EPOS/FoodIcons/rice.svg';
import salami from '~Assets/icons/EPOS/FoodIcons/salami.svg';
import sausage from '~Assets/icons/EPOS/FoodIcons/sausage.svg';
import sell from '~Assets/icons/EPOS/FoodIcons/sell.svg';
import shrimp from '~Assets/icons/EPOS/FoodIcons/shrimp.svg';
import soup from '~Assets/icons/EPOS/FoodIcons/soup.svg';
import soupHotBowl from '~Assets/icons/EPOS/FoodIcons/soup-hot-bowl.svg';
import starIcon from '~Assets/icons/EPOS/FoodIcons/star.svg';
import steak from '~Assets/icons/EPOS/FoodIcons/steak.svg';
import stockpot from '~Assets/icons/EPOS/FoodIcons/stockpot.svg';
import sushi from '~Assets/icons/EPOS/FoodIcons/sushi.svg';
import sushi2 from '~Assets/icons/EPOS/FoodIcons/sushi-2.svg';
import taco from '~Assets/icons/EPOS/FoodIcons/taco.svg';
import takeout from '~Assets/icons/EPOS/FoodIcons/takeout.svg';
import vegetables from '~Assets/icons/EPOS/FoodIcons/vegetables.svg';
import wineBottle from '~Assets/icons/EPOS/FoodIcons/wine-bottle.svg';

/** Backoffice icon value (lower-cased, underscores as dashes, e.g. "ICE_CREAM" -> "ice-cream") -> the SVG under Assets/icons/EPOS/FoodIcons. */
const CATEGORY_ICONS: Record<string, string> = {
  add: addIcon,
  beer,
  bowl,
  breakfast,
  burger,
  'burger-menu': burgerMenu,
  cake,
  celebration,
  'chef-hat': chefHat,
  chicken,
  'chili-sauce': chiliSauce,
  cocktail,
  coffee,
  'coffee-takeaway': coffeeTakeaway,
  cookie,
  cow,
  croissant,
  dining,
  drink,
  dumpling,
  favorite,
  fish,
  'fish-2': fish2,
  fries,
  grill,
  home: homeIcon,
  'ice-cream': iceCream,
  juice,
  kebab,
  'kebab-2': kebab2,
  lobster,
  pig,
  pizza,
  plate,
  'plus-one': plusOne,
  ramen,
  rice,
  salami,
  sausage,
  sell,
  shrimp,
  soup,
  'soup-hot-bowl': soupHotBowl,
  star: starIcon,
  steak,
  stockpot,
  sushi,
  'sushi-2': sushi2,
  taco,
  takeout,
  vegetables,
  'wine-bottle': wineBottle,
};

/** The icon for a category's `icon` value, matched case-insensitively with "_" and "-" interchangeable ("ICE_CREAM", "ice-cream"). Undefined when there is none. */
export const categoryIconSrc = (icon: string | null | undefined): string | undefined => {
  if (!icon) {
    return undefined;
  }
  return CATEGORY_ICONS[icon.trim().toLowerCase().replace(/_/g, '-')];
};
